import "./discard-edits-modal.css";

import { SvgIcon } from "@tql/ui-components-react/kendo/common";
import { alertTriangle } from "@tql/ui-components-react/untitled/icons";

import { TraxModal } from "~/shared/components/trax-modal/trax-modal.tsx";

export const DiscardEditsModal = ({
	onKeepEditing,
	onDiscard,
	isOpen,
}: {
	onKeepEditing: () => void;
	onDiscard: () => void;
	isOpen: boolean;
}) => {
	if (!isOpen) {
		return null;
	}

	return (
		<TraxModal
			cancelText={"Keep editing"}
			className={"discard-edits-modal"}
			confirmText={"Discard changes"}
			confirmVariant={"danger"}
			onCancel={onKeepEditing}
			onClose={onKeepEditing}
			onConfirm={onDiscard}
			showConfirmationButtons={true}
			title={"Discard Shipment Edits"}
			type={"error"}
		>
			<div>
				<SvgIcon
					icon={alertTriangle}
					size={"xxxlarge"}
					style={{ color: "var(--kendo-color-error)" }}
				/>
				<span>
					<span>Are you sure you want to abandon these changes?</span>
					<span>All information will be lost.</span>
				</span>
			</div>
		</TraxModal>
	);
};
